<ui-modal #modal title="Edit Stock Item" size="md" (modalClosed)="onModalClosed()">
  @if (stockItem) {
    <div class="space-y-6">
      <!-- Weight or Volume controls -->
      @if (isWeightOrVolume()) {
        <div class="space-y-4">
          <!-- Current quantity display -->
          <div class="text-center">
            <h5 class="text-lg font-semibold mb-2">Current Quantity</h5>
            <p class="text-4xl font-bold mb-3">
              {{ quantityLeft | number:'1.0-2' }} / {{ quantityFull | number:'1.0-2' }}
              @if (stockItem.unit) {
                <span class="text-2xl">{{ stockItem.unit }}</span>
              }
            </p>
          </div>

          <!-- Interactive Range Slider -->
          <div>
            <label class="label">
              <span class="label-text font-medium">Adjust Quantity</span>
              <span class="label-text-alt font-semibold">{{ sliderValue | number:'1.0-0' }}%</span>
            </label>
            <ui-range
              [min]="0"
              [max]="100"
              [step]="1"
              [(ngModel)]="sliderValue"
              (valueChange)="onSliderChange($event)"
              variant="primary">
            </ui-range>
          </div>

          <!-- Quick access buttons -->
          <div>
            <label class="label">
              <span class="label-text font-medium">Quick Select</span>
            </label>
            <div class="flex gap-2 w-full">
              <button type="button" class="btn btn-outline btn-primary flex-1" (click)="setQuickValue(0)">Empty</button>
              <button type="button" class="btn btn-outline btn-primary flex-1" (click)="setQuickValue(25)">¼</button>
              <button type="button" class="btn btn-outline btn-primary flex-1" (click)="setQuickValue(50)">½</button>
              <button type="button" class="btn btn-outline btn-primary flex-1" (click)="setQuickValue(75)">¾</button>
              <button type="button" class="btn btn-outline btn-primary flex-1" (click)="setQuickValue(100)">Full
              </button>
            </div>
          </div>

          <!-- Precise value input -->
          <div class="form-control">
            <label class="label">
              <span class="label-text font-medium">Precise Value</span>
            </label>
            <div class="join w-full">
              <input
                type="number"
                class="input input-bordered join-item flex-1"
                [(ngModel)]="quantityLeft"
                (ngModelChange)="onQuantityLeftChange()"
                [max]="quantityFull"
                min="0"
                step="0.01">
              @if (stockItem.unit) {
                <span class="btn btn-disabled join-item">{{ stockItem.unit }}</span>
              }
            </div>
          </div>

          <!-- Variable: correct total weight (rarely needed) -->
          @if (quantityType === 'variable') {
            <details class="mt-1">
              <summary class="text-xs text-base-content/40 cursor-pointer select-none hover:text-base-content/60 w-fit">
                Correct total weight…
              </summary>
              <div class="mt-3 form-control">
                <div class="join w-full">
                  <input
                    type="number"
                    class="input input-bordered input-sm join-item flex-1"
                    [(ngModel)]="quantityFull"
                    (ngModelChange)="onQuantityFullChange()"
                    min="0"
                    step="0.01"
                    placeholder="Total weight">
                  @if (stockItem.unit) {
                    <span class="btn btn-sm btn-disabled join-item">{{ stockItem.unit }}</span>
                  }
                </div>
                <p class="text-xs text-base-content/40 mt-1">Updates the recorded total for this item only.</p>
              </div>
            </details>
          }
        </div>
      }

      <!-- Piece controls -->
      @if (isPiece()) {
        <div class="space-y-4">
          <!-- Increment/Decrement buttons -->
          <div class="flex justify-center items-center gap-6">
            <button
              type="button"
              class="btn-piece-control"
              (click)="decrementPiece()"
              [disabled]="quantityLeft <= 0">
              <span class="text-5xl leading-none select-none">−</span>
            </button>
            <div class="text-center min-w-25">
              <h2 class="text-5xl font-bold mb-0">{{ quantityLeft | number:'1.0-0' }}</h2>
              <small class="text-base-content/60">of {{ quantityFull | number:'1.0-0' }}</small>
            </div>
            <button
              type="button"
              class="btn-piece-control"
              (click)="incrementPiece()"
              [disabled]="quantityLeft >= quantityFull">
              <span class="text-5xl leading-none select-none">+</span>
            </button>
          </div>

          <!-- Precise value input for pieces -->
          <div class="form-control">
            <label class="label">
              <span class="label-text font-medium">Exakte Anzahl</span>
              <span class="label-text-alt text-base-content/60">0–{{ quantityFull }}</span>
            </label>
            <ui-input
              [type]="'number'"
              [fullWidth]="true"
              [value]="quantityLeft.toString()"
              (valueChange)="quantityLeft = clampNumber($event)"
            ></ui-input>
          </div>
        </div>
      }

      <!-- Temperature zone (shown regardless of quantity unit) -->
      <div class="form-control">
        <label class="label">
          <span class="label-text font-medium">Temperature zone</span>
        </label>
        <div class="join w-full">
          @for (zone of zoneButtons; track zone.value) {
            <label
              class="join-item btn flex-1 gap-2 whitespace-nowrap"
              [class.btn-active]="selectedZone === zone.value"
              [attr.aria-label]="zone.label">
              <input
                type="radio"
                name="temperature-zone"
                class="sr-only"
                [value]="zone.value"
                [(ngModel)]="selectedZone" />
              <fa-icon [icon]="zone.icon"></fa-icon>
              <span>{{ zone.label }}</span>
            </label>
          }
        </div>
      </div>
    </div>
  }

  <!-- Footer actions -->
  <div modal-footer class="flex gap-2 justify-end">
    <ui-button variant="ghost" (click)="cancel()">Cancel</ui-button>
    <ui-button variant="success" (click)="save()">Save</ui-button>
  </div>
</ui-modal>
